/**
 * @generated SignedSource<<c86a787746f5041dfad9061d9ac72507>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accessOneDeliveryGateQuery$variables = Record<PropertyKey, never>;
export type accessOneDeliveryGateQuery$data = {
  readonly onedeliveryAccess: boolean;
};
export type accessOneDeliveryGateQuery = {
  response: accessOneDeliveryGateQuery$data;
  variables: accessOneDeliveryGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "onedeliveryAccess",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accessOneDeliveryGateQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accessOneDeliveryGateQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "e00c33fcd7ecf37e37b910a801b65fb5",
    "id": null,
    "metadata": {},
    "name": "accessOneDeliveryGateQuery",
    "operationKind": "query",
    "text": "query accessOneDeliveryGateQuery {\n  onedeliveryAccess\n}\n"
  }
};
})();

(node as any).hash = "c2995c7e5ddda94c7170d32f6aff9a19";

export default node;
